import { IHttpClient } from '../@interfaces/IHttpClient';
import { CategoryMapper } from '../mappers/CategoryMapper';

export class CategoriesService {
  constructor(private readonly httpClient: IHttpClient) {}

  create({ description }: { description: string }) {
    return this.httpClient.post('/category/new', {
      body: {
        description,
      },
    });
  }

  update(id: string, { description }: { description: string }) {
    return this.httpClient.put(`/category/${id}`, {
      body: {
        description,
      },
    });
  }

  async delete(id: string) {
    return this.httpClient.delete(`/category/${id}`);
  }

  async list() {
    const { body, statusCode } = await this.httpClient.get('/categories');

    if (statusCode !== 200) {
      return { statusCode, body };
    }

    const categories = body.categories.map(CategoryMapper.toDomain);

    return {
      statusCode,
      body: categories,
    };
  }

  getCategoryStats(year: string, userID?: string) {
    return this.httpClient.post('/report/categories/statsByYear', {
      body: {
        filter: {
          year,
          userID,
        },
      },
    });
  }

  async exportCategoryStats(year: string) {
    const response = await this.httpClient.post(
      '/report/categories/statsByYear/excel',
      {
        body: {
          filter: {
            year,
          },
        },
        responseType: 'blob',
      },
    );

    if (response.statusCode !== 200) {
      return response;
    }

    return {
      ...response,
      body: new Blob([response.body]),
    };
  }
}
